import React from 'react';
import { PRODUCT_PER_PAGE } from '../../../utils/constants/product';
import { parse } from 'path';

type Props = {
    productCount: number;
    pageNo: number;
};

export default function ResultCount(props: Props) {
    const { productCount, pageNo } = props;

    let loadedResult = pageNo * PRODUCT_PER_PAGE;
    if (loadedResult > productCount) {
        loadedResult = productCount;
    }

    return (
        <p className="text-xs text-center leading-6 text-brand-gray">
            {`1 - ${loadedResult} out of ${productCount} Products`}
        </p>
    );
}
